module.exports = __webpack_public_path__ + "static/bg_modal-6b5faa8d3c5443edbcabcdfc10af84e8.png";